export default __webpack_public_path__ + "static/media/ArrowLeft.8f7dc904.svg";